APP = window.APP || {};
// --------------------------------------------------------------------------
// init.js
// --------------------------------------------------------------------------
// This file imports and initialises modules.
// Add module names to the modules array for automatic initialisation.
// No specific javascript should be placed in this file.
// --------------------------------------------------------------------------

$(function() {
    'use strict';

    if (bowser.msie && bowser.version <= 9) {
      return;
    }

    if (win.data('scrollPosition') === 0) win.data('scrollPosition', win.scrollTop());

    if (APP.Elements.body.hasClass('dashboard-page')) {
        APP.MODULES.dashboard.init();
    }
    else {
        APP.MODULES.page.init();
    }
});
